// AUTO-GENERATED SQL Builder (V40 Final) for PackageItem
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class PackageItemSql {
  private ast = new SqlAst('PackageItem', 'packageItem');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringPackageId: SqlField;
  public offeringId: SqlField;
  public srcMode: SqlField;
  public srcOfferingPackageId: SqlField;
  public srcEventSessionId: SqlField;
  public heads: SqlField;
  public extraPrice: SqlField;
  public sortOrder: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringPackage: SqlNavHybrid;
  public srcEventSession: SqlNavHybrid;
  public srcOfferingPackage: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingPackageItemQtyList: SqlNavHybrid;
  public offeringMilestoneShareList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('packageItem', 'guid', '', 'id', 'packageItem_guid');
    this.offeringPackageId = new SqlField('packageItem', 'offeringPackageId', 'offeringPackage', 'id', 'packageItem_offeringPackage');
    this.offeringId = new SqlField('packageItem', 'offeringId', 'offering', 'id', 'packageItem_offering');
    this.srcMode = new SqlField('packageItem', 'srcMode', '', 'id', 'packageItem_srcMode');
    this.srcOfferingPackageId = new SqlField('packageItem', 'srcOfferingPackageId', '', 'id', 'packageItem_srcOfferingPackage');
    this.srcEventSessionId = new SqlField('packageItem', 'srcEventSessionId', '', 'id', 'packageItem_srcEventSession');
    this.heads = new SqlField('packageItem', 'heads', '', 'id', 'packageItem_heads');
    this.extraPrice = new SqlField('packageItem', 'extraPrice', '', 'id', 'packageItem_extraPrice');
    this.sortOrder = new SqlField('packageItem', 'sortOrder', '', 'id', 'packageItem_sortOrder');
    this.createdByUser = createNavHybrid('packageItem', 'packageItem_createdByUser', 'User');
    this.offering = createNavHybrid('packageItem', 'packageItem_offering', 'Offering');
    this.offeringPackage = createNavHybrid('packageItem', 'packageItem_offeringPackage', 'OfferingPackage');
    this.srcEventSession = createNavHybrid('packageItem', 'packageItem_srcEventSession', 'EventSession');
    this.srcOfferingPackage = createNavHybrid('packageItem', 'packageItem_srcOfferingPackage', 'OfferingPackage');
    this.updatedByUser = createNavHybrid('packageItem', 'packageItem_updatedByUser', 'User');
    this.bookingPackageItemQtyList = createNavHybrid('packageItem', 'packageItem_bookingPackageItemQtyList', 'BookingPackageItemQty');
    this.offeringMilestoneShareList = createNavHybrid('packageItem', 'packageItem_offeringMilestoneShareList', 'OfferingMilestoneShare');
    this.id = new SqlField('packageItem', 'id', '', 'id', 'packageItem_id');
    this.isDeleted = new SqlField('packageItem', 'isDeleted', '', 'id', 'packageItem_isDeleted');
    this.createdBy = new SqlField('packageItem', 'createdBy', '', 'id', 'packageItem_createdBy');
    this.createdDate = new SqlField('packageItem', 'createdDate', '', 'id', 'packageItem_createdDate');
    this.updatedBy = new SqlField('packageItem', 'updatedBy', '', 'id', 'packageItem_updatedBy');
    this.updatedDate = new SqlField('packageItem', 'updatedDate', '', 'id', 'packageItem_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:PackageItemSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:PackageItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:PackageItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:PackageItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:PackageItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:PackageItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:PackageItemSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:PackageItemSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:PackageItemSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:PackageItemSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
